/** gtmCategory (Page) of the TCSP-8390 GA spec: the match card lists (PP, Sport, My Matches) or the Match Detail (More Market) page. */
export type ScorePredictionPromotionGaPage = 'MatchCard' | 'MatchDetail';

/** Label of the TCSP-8390 GA spec: the badge beside the league name or on the Full Time Correct Score title. */
export type ScorePredictionPromotionGaLabel = 'League' | 'CS';

/**
 * GTM class name for the Score Prediction promotion badge (Castor tracks GA through CSS classes that GTM
 * triggers select on): `<Page>_Btn_ScorePredIcon<Label>`. GTM fires both the click and the view
 * (`…_View`, Element Visibility) from this one class (Junelson, 2026-10-07).
 */
export function scorePredictionPromotionGaClass(page: ScorePredictionPromotionGaPage, label: ScorePredictionPromotionGaLabel): string {
    return `${page}_Btn_ScorePredIcon${label}`;
}
